import * as fullIcon from './full'
import * as smallIcon from './small'
import { ReactComponent as eye } from './eye.svg'

export const icons = {
    full: fullIcon,
    small: smallIcon,
    others: { eye }
}
